/* PUNIVERSE build — homepage motion. Ported from site/src/components/Landing.tsx (buildTimelines).
   Loaded on templates/index only, after ge-gsap / ge-scrolltrigger / ge-lenis.

   Rules carried over from the preview, all hard-won:
     1. Build ScrollTriggers only after document.fonts.ready — Fraunces loads late and shifts every
        pinned section by ~290px, so triggers created earlier fire at the wrong scroll positions.
     2. Reduced motion drops only AUTONOMOUS motion (Lenis inertia, entrance staggers). The scrubbed
        film is user-driven and stays for everyone, or the page is static on any Mac with Reduce
        Motion on — which is most of them, including Jason's.
     3. The theme editor (Shopify.designMode) re-renders sections in place, which detaches pinned
        elements from their placeholders — so pins are skipped there and the slides simply show.
     4. .ingredient slides are opacity:0/visibility:hidden in CSS. If this script never runs, the
        html.ge-motion class is absent and ge-theme.css reveals the first slide instead. */
(function () {
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var designMode = !!(window.Shopify && window.Shopify.designMode);
  document.documentElement.classList.add('ge-motion');

  function start() {
    var gsap = window.gsap;
    var ScrollTrigger = window.ScrollTrigger;
    if (!gsap || !ScrollTrigger) return;
    gsap.registerPlugin(ScrollTrigger);
    var q = function (sel) {
      return Array.prototype.slice.call(document.querySelectorAll(sel));
    };

    /* ---- smooth scroll (autonomous inertia) ---- */
    if (window.Lenis && !reduce && !designMode) {
      var lenis = new window.Lenis({ lerp: 0.09 });
      window.__geLenis = lenis;
      lenis.on('scroll', ScrollTrigger.update);
      gsap.ticker.add(function (t) {
        lenis.raf(t * 1000);
      });
      gsap.ticker.lagSmoothing(0);
      document.documentElement.classList.add('lenis', 'lenis-smooth');
    }

    /* ---- HERO ---- */
    if (document.querySelector('.hero')) {
      gsap.set('.hero__title .line > span', { yPercent: reduce ? 0 : 110 });
      if (!reduce) {
        gsap.to('.hero__title .line > span', {
          yPercent: 0,
          duration: 1.5,
          ease: 'power4.out',
          stagger: 0.14,
          delay: 0.15,
        });
      }
      gsap.to('.hero__media', {
        scale: 1.14,
        ease: 'none',
        scrollTrigger: { trigger: '.hero', start: 'top top', end: 'bottom top', scrub: true },
      });
      gsap.to('.hero__content', {
        yPercent: -18,
        opacity: 0,
        ease: 'none',
        scrollTrigger: { trigger: '.hero', start: 'top top', end: '70% top', scrub: true },
      });
    }

    /* ---- section reveals ---- */
    if (!reduce) {
      q('.story [data-reveal], .why [data-reveal], .collections [data-reveal], .products [data-reveal], .voices [data-reveal], .ritual [data-reveal], .home-journal [data-reveal]').forEach(
        function (el) {
          gsap.fromTo(
            el,
            { y: 44, opacity: 0 },
            {
              y: 0,
              opacity: 1,
              duration: 1.15,
              ease: 'power3.out',
              scrollTrigger: { trigger: el, start: 'top 86%' },
            }
          );
        }
      );
    }

    /* ---- INGREDIENTS: pinned scrub through the botanicals ---- */
    var slides = q('.ingredient');
    var dots = q('.ingredients__progress i');
    if (slides.length) {
      if (designMode) {
        gsap.set(slides, { autoAlpha: 0, y: 0 });
        gsap.set(slides[0], { autoAlpha: 1 });
      } else {
        gsap.set(slides, { autoAlpha: 0, y: 46 });
        var ing = gsap.timeline({
          scrollTrigger: {
            trigger: '.ingredients__stage',
            start: 'top top',
            end: '+=' + slides.length * 620,
            pin: true,
            scrub: 0.6,
            onUpdate: function (st) {
              var i = Math.min(slides.length - 1, Math.floor(st.progress * slides.length));
              dots.forEach(function (d, j) {
                d.classList.toggle('on', j === i);
              });
            },
          },
        });
        slides.forEach(function (s, i) {
          ing.to(s, { autoAlpha: 1, y: 0, duration: 0.55, ease: 'power2.out' });
          if (i < slides.length - 1) {
            ing.to(s, { autoAlpha: 0, y: -40, duration: 0.45, ease: 'power2.in' }, '+=0.55');
          }
        });
      }
    }

    /* ---- RITUAL: sticky film unzoom ---- */
    if (document.querySelector('.ritual__media video')) {
      gsap.to('.ritual__media video', {
        scale: 1,
        ease: 'none',
        scrollTrigger: { trigger: '.ritual', start: 'top bottom', end: 'bottom top', scrub: true },
      });
    }

    /* ---- BOTANIC: word-by-word quote scrub ---- */
    var words = q('.botanic__quote .word');
    if (words.length) {
      gsap.set(words, { opacity: 0.14, y: 8 });
      gsap.to(words, {
        opacity: 1,
        y: 0,
        stagger: 0.06,
        ease: 'none',
        scrollTrigger: { trigger: '.botanic', start: 'top 60%', end: 'bottom bottom', scrub: 0.5 },
      });
    }

    /* ---- PRODUCTS film unzoom ---- */
    if (document.querySelector('.products__film video')) {
      gsap.to('.products__film video', {
        scale: 1,
        ease: 'none',
        scrollTrigger: {
          trigger: '.products__film',
          start: 'top bottom',
          end: 'bottom top',
          scrub: true,
        },
      });
    }

    /* ---- FINALE ---- */
    if (document.querySelector('.finale__in')) {
      gsap.fromTo(
        '.finale__in',
        { y: 90, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          ease: 'none',
          scrollTrigger: { trigger: '.finale', start: 'top 70%', end: 'top 8%', scrub: 0.5 },
        }
      );
    }

    ScrollTrigger.refresh();
    window.__ready = true;
  }

  if (document.fonts && document.fonts.ready) document.fonts.ready.then(start);
  else window.addEventListener('load', start);
})();
